
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetContentList } from "@/request/common";
@Component({})
export default class Name extends mixins(listMixin) {
  @Prop()
  private selectData: any;
  @Prop()
  private visible: boolean | undefined;
  @Watch("visible", { immediate: true })
  private visibleChange() {
    this.ifShow = this.visible;
    if (this.visible) {
      this.multipleSelection = [];
      this.search();
    }
  }
  private ifShow: any = false;
  private data: any = [];
  private get patient() {
    return this.$store.state.patient;
  }
  private get href() {
    return window.location.href;
  }
  private cancel() {
    this.$emit("cancel");
  }
  private goSure() {
    // this.toggleSelection([this.selectData]);
    // return;
    if (this.multipleSelection.length == 0) {
      this.$message.warning("请选择需要比对的数据");
      return;
    }
    if (this.multipleSelection.length < 2) {
      this.$message.warning("请选择2份数据进行比较");
      return;
    }
    if (this.multipleSelection.length > 2) {
      this.$message.warning("只支持选择2份数据进行比较");
      return;
    }
    this.cancel();
    let ids: any = [];
    this.multipleSelection.forEach((ele: any) => {
      ids.push(ele.id);
    });
    // const url: any = this.href.split("/#/")[0];
    // window.open(
    //   url + "/#/main/report/ceping-report?ids=" + JSON.stringify(ids)
    // );
    this.$router.push({
      path: "/main/report/ceping-bidui",
      query: {
        ids: JSON.stringify(ids),
      },
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        page: this.filters.current_page,
        patient_id: this.patient.id,
        limit: 200,
        has_related_type: true,
        has_report_type: true,
        template_id: this.selectData.template.id,
      },
    };
    GetContentList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      const index: any = res.data.findIndex((val: any) => {
        return val.id == this.selectData.id;
      });
      setTimeout(() => {
        (this.$refs.biduiTable as any).toggleRowSelection(res.data[index]);
        this.$forceUpdate();
      }, 1000);
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  private toggleSelection(rows: any) {
    if (rows) {
      rows.forEach((row: any) => {
        (this.$refs.biduiTable as any).toggleRowSelection(row);
        this.$forceUpdate();
      });
    } else {
      (this.$refs.biduiTable as any).clearSelection();
    }
  }
}
